import AppShell from "./layout/AppShell";
import ErrorBoundary from "./ErrorBoundary";
import GoalsSummary from "./goals/GoalsSummary";
import Allocation from "./home/Allocation";
import Contribution from "./home/Contribution";
import Ladder from "./home/Ladder";
import Overview from "./home/Overview";
import PortfolioChart from "./home/PortfolioChart";
import SavingPace from "./home/SavingPace";
import Summary from "./home/Summary";

const Home = () => {
	return (
		<AppShell>
			<ErrorBoundary title="Portfolio summary unavailable">
				<Summary />
			</ErrorBoundary>

			<ErrorBoundary title="Portfolio chart unavailable">
				<PortfolioChart />
			</ErrorBoundary>

			<div className="grid items-start gap-6 lg:grid-cols-2">
				<ErrorBoundary title="Allocation unavailable">
					<Allocation />
				</ErrorBoundary>
				<ErrorBoundary title="Goals unavailable">
					<GoalsSummary />
				</ErrorBoundary>
			</div>

			<div className="grid items-start gap-6 lg:grid-cols-2">
				<ErrorBoundary title="Contribution to return unavailable">
					<Contribution />
				</ErrorBoundary>
				<ErrorBoundary title="Saving pace unavailable">
					<SavingPace />
				</ErrorBoundary>
			</div>

			<ErrorBoundary title="Holdings unavailable">
				<Overview />
			</ErrorBoundary>

			<section aria-labelledby="yearly-performance-heading" className="space-y-4">
				<div>
					<h2 id="yearly-performance-heading" className="text-lg font-semibold text-slate-900">
						Year-by-year performance
					</h2>
					<p className="mt-0.5 text-sm text-slate-500">
						Investment years run 12 December to 11 December. Each year starts from the
						previous year's closing value plus that year's new capital.
					</p>
				</div>
				<ErrorBoundary title="Year-by-year performance unavailable">
					<Ladder />
				</ErrorBoundary>
			</section>
		</AppShell>
	);
};

export default Home;
